import React, { Component } from "react";
import { IntroPage } from "app/components/IntroPage";
import './ChannelHomeComponent.scss';

class ChannelHome extends Component{
    render() {
        return (
            <IntroPage headerText="Welcome to Channels Homepage">                
                <b>Here you can</b>
                <ul className="introHomeItems">
					<li>Manage channels</li>
			    </ul>
            </IntroPage>
        )
    }
}

export default ChannelHome;